module.exports = __webpack_public_path__ + "img/star-filled.8e30e63b.svg";